import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VRow,
    { staticClass: "pb-2 pr-2" },
    [
      _c(
        VCol,
        { staticClass: "col-12 col-md-12 col-xl-12 mt-3 pr-0" },
        [
          _c(
            VCard,
            { staticClass: "pt-2" },
            [
              _c(VTextField, {
                staticClass: "mt-1 mr-2 mb-0 ml-2 pb-0",
                attrs: {
                  label: "Buscar miembro de equipo...",
                  outlined: "",
                  clearable: "",
                  dense: "",
                },
                on: { input: _vm.onSearch },
                model: {
                  value: _vm.filterText,
                  callback: function ($$v) {
                    _vm.filterText = $$v
                  },
                  expression: "filterText",
                },
              }),
              _c(
                VList,
                { staticClass: "mt-0 pt-0 scrollable-vertical-card" },
                _vm._l(_vm.listTeamMembers, function (listTeamMember, index) {
                  return _c(
                    VListItem,
                    { key: index },
                    [
                      _c(
                        VListItemAvatar,
                        [
                          _c(VChip, { staticClass: "primary white--text" }, [
                            _vm._v(
                              _vm._s(
                                listTeamMember.user
                                  ? listTeamMember.user
                                      .slice(0, 1)
                                      .toUpperCase()
                                  : "?"
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        VListItemContent,
                        [
                          _c(VListItemTitle, [
                            _vm._v(_vm._s(listTeamMember.user)),
                          ]),
                          _c(VListItemSubtitle, [
                            listTeamMember.roles &&
                            listTeamMember.roles.length > 0
                              ? _c(
                                  "span",
                                  _vm._l(
                                    listTeamMember.roles,
                                    function (role, roleIndex) {
                                      return _c(
                                        VChip,
                                        {
                                          key: roleIndex,
                                          staticClass: "small mr-1",
                                        },
                                        [_vm._v(_vm._s(role))]
                                      )
                                    }
                                  ),
                                  1
                                )
                              : _c(
                                  "span",
                                  [
                                    _c(
                                      VChip,
                                      { staticClass: "small outlined" },
                                      [_vm._v("Sin rol")]
                                    ),
                                  ],
                                  1
                                ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        VListItemAction,
                        [
                          _c(VCheckbox, {
                            on: {
                              change: function ($event) {
                                return _vm.toggleCheck(listTeamMember.user)
                              },
                            },
                            model: {
                              value: _vm.checkedMailsMap[listTeamMember.user],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.checkedMailsMap,
                                  listTeamMember.user,
                                  $$v
                                )
                              },
                              expression:
                                "checkedMailsMap[listTeamMember.user]",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }